import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = import.meta.env.VITE_SITE_NAME || 'Cripto News';
const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://criptonews.site';

const TOOLS = [
  {
    to: '/ferramentas/calculadora-dca',
    icon: '📈',
    title: 'Calculadora DCA',
    desc: 'Simule aportes recorrentes em cripto com preços históricos reais em BRL, preço médio e gráfico.',
  },
  {
    to: '/ferramentas/calculadora-de-lucro',
    icon: '🧮',
    title: 'Calculadora de Lucro',
    desc: 'Lucro bruto, taxas e lucro líquido de uma operação de compra e venda.',
  },
  {
    to: '/ferramentas/conversor',
    icon: '💱',
    title: 'Conversor',
    desc: 'Converta entre reais e criptomoedas (e cripto ↔ cripto) com cotação atualizada.',
  },
  {
    to: '/ferramentas/calculadora-staking',
    icon: '🌱',
    title: 'Calculadora de Staking',
    desc: 'Estime rendimentos com juros compostos a partir de uma taxa anual (APR).',
  },
  {
    to: '/ferramentas/gas',
    icon: '⛽',
    title: 'Taxa de Gás (Ethereum)',
    desc: 'Taxa-base e níveis de prioridade em gwei, com custo estimado em reais.',
  },
  {
    to: '/arbitrage',
    icon: '⚡',
    title: 'Monitor de Arbitragem',
    desc: 'Diferenças de preço entre exchanges em tempo real, com taxas e ganho líquido estimado.',
  },
  {
    to: '/ferramentas/comparador-exchanges',
    icon: '🏦',
    title: 'Comparador de Exchanges',
    desc: 'Taxas, Pix, KYC e recursos das principais exchanges disponíveis no Brasil.',
  },
];

export const FerramentasPage: React.FC = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `Ferramentas Cripto | ${SITE_NAME}`,
    url: `${SITE_URL}/ferramentas`,
    inLanguage: 'pt-BR',
    publisher: { '@type': 'Organization', name: SITE_NAME, url: SITE_URL },
  };

  return (
    <>
      <Helmet>
        <title>Ferramentas Cripto Gratuitas | {SITE_NAME}</title>
        <meta
          name="description"
          content="Ferramentas gratuitas para o investidor cripto brasileiro: calculadora DCA, calculadora de lucro, conversor BRL, staking, taxa de gás do Ethereum, arbitragem e comparador de exchanges."
        />
        <link rel="canonical" href={`${SITE_URL}/ferramentas`} />
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <div className="container mx-auto px-4 py-10 max-w-4xl">
          <nav className="text-sm text-gray-500 mb-4 flex items-center gap-2">
            <Link to="/" className="hover:text-blue-600 transition">Início</Link>
            <span>›</span>
            <span className="text-gray-700">Ferramentas</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">Ferramentas</h1>
          <p className="text-gray-600 leading-relaxed mb-8 max-w-2xl">
            Calculadoras e monitores gratuitos para acompanhar o mercado cripto e tomar decisões mais
            informadas — sempre com fonte de dados e horário de atualização identificados. Nenhuma
            ferramenta constitui recomendação de investimento.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {TOOLS.map((tool) => (
              <Link
                key={tool.to}
                to={tool.to}
                className="bg-white rounded-xl shadow p-6 hover:shadow-lg transition flex items-start gap-4"
              >
                <span className="text-3xl flex-shrink-0">{tool.icon}</span>
                <div>
                  <h2 className="font-bold text-gray-900 mb-1">{tool.title}</h2>
                  <p className="text-gray-600 text-sm leading-relaxed">{tool.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
